import { Badge, Tooltip } from "@/components/ui";

import { cx } from "@/lib/tailwind-utils";

interface PopularBadgeProps {
  className?: string;
  /** Null drops the tooltip, e.g. inside a card that is itself a button. */
  tooltip?: string | null;
}

/** Staff-set "Popular" highlight shared by self-scheduling and the online shop. */
export const PopularBadge = ({
  className,
  tooltip = "Patients love this service!",
}: PopularBadgeProps) => {
  const badge = (
    <Badge
      className={cx(
        "shrink-0 bg-primary text-primary-foreground uppercase text-tiny rounded-full py-0.5",
        className,
      )}
    >
      Popular
    </Badge>
  );
  if (tooltip === null) return badge;
  return (
    <Tooltip content={tooltip} triggerAsChild>
      {badge}
    </Tooltip>
  );
};
